<template>
  <div>
    <div
      v-for="(item, index) in unidataRadio"
      :key="item.id"
      class="row no-gutters unidata-editor-correlator-option-list"
    >
      <div class="col-6">
        <el-radio v-model="currentUnidataEditor" :label="index" style="margin-left:0;">
          <label
            v-tooltip="uniToolTipTranslation(item.label, 'en-US')"
            style=" display:inline-block;"
            @click="currentUnidataEditor = index"
          >
            {{ uniTranslation(item.label) }}
          </label>
        </el-radio>
      </div>
      <div class="col-6">
        <UnidataEditor
          class="pl-2"
          style="display:inline-block;"
          :parent-path="parentPath"
          :name="item.name"
          :unidata-editor-columns="'col-8'"
          :show-input="currentUnidataEditor === index ? 1 : 0"
          :show-output1="currentUnidataEditor !== index ? 1 : 0"
        ></UnidataEditor>
      </div>
    </div>
  </div>
</template>

<script>
import jsonHelper from "../../shared/jsonHelper";
import { mapGetters } from "vuex";
import conversionService from "../../services/backend/conversionService";
import { Radio } from "element-ui";
import UnidataEditor from "./UnidataEditor.vue";
export default {
  components: {
    "el-radio": Radio,
    UnidataEditor
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    group: {
      type: String,
      required: true
    },
    cssClass: {
      type: String,
      default: "col-6"
    },
    selectedOptionIndex: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      currentUnidataEditor: 0,
      unidataEditors: [],
      unsubscribes: [],
      unidataRadio: []
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"]),
    order() {
      if (this.unidataRadio.length === 0) return 9999;
      return this.unidataRadio[this.currentUnidataEditor].order;
    }
  },
  watch: {
    currentUnidataEditor: function(newval /*, oldval*/) {
      var that = this;
      if (newval != undefined) {
        /*this.unidataEditors(newval).isOptionSelected = true;
          this.unidataEditors(oldval).isOptionSelected = false;*/
        //QUI LOGICA DI SWITCH INPUT OUTPUT TRA 'OLD' E 'NEW' VAL
        that.$emit("update:selectedOptionIndex", newval);
      }
    }
  },
  destroyed: function() {
    this.unsubscribes.forEach(function(u) {
      u();
    });
  },
  mounted: function() {
    var that = this;
    var datas = jsonHelper.getProperty(this.projects, this.parentPath);
    for (var d in datas) {
      if (datas[d].group != undefined && datas[d].group !== null && datas[d].group == this.group) {
        this.unidataRadio.push({
          id: this.group + "_" + this.unidataRadio.length + 1,
          label: datas[d].label,
          name: "." + d,
          dato: datas[d],
          order: datas[d].order,
          group: this.group,
          path: this.parentPath + "." + d
        });
      }
    }

    that.unidataRadio = that.unidataRadio.sort(function(a, b) {
      return a.order <= b.order ? -1 : 1;
    });

    that.$nextTick(function() {
      that.unidataRadio.forEach(function(el /*, index*/) {
        that.unsubscribes.push(
          that.$store.subscribe(function(mutation /*, state*/) {
            let path = el.path + ".input.refValue.value";
            // let unidataIndex = index;
            if (mutation.type === "changeProjectProperty") {
              if (mutation.payload.path.startsWith(path)) {
                var prjName = path.substring(0, path.indexOf("."));

                var unidatoCorrelation = {
                  changedPath: path,
                  correlationList: [],
                  group: el.group,
                  project: that.projects[prjName]
                };
                that.unidataRadio.forEach(function(el /*, index*/) {
                  unidatoCorrelation.correlationList.push({
                    path: el.path,
                    unidato: jsonHelper.getProperty(that.projects, el.path)
                  });
                });
                conversionService.convertCorrelatedUnidata(unidatoCorrelation).then(function(data) {
                  data.forEach(function(el /*, index*/) {
                    that.$store.dispatch("updateUnidato", { path: el.path, unidato: el.unidato });
                  });
                });
              }
            }
          })
        );
      });
    });
  }
};
</script>

<style lang="scss">
.unidata-editor-correlator-option-list > .col-6 > .el-radio {
  margin: 10px 0 10px 0px;
  //padding: 10px 0;
}
.unidata-editor-correlator-option-list .el-radio .el-radio__input .el-radio__label {
  height: 30px !important;
}
</style>
